import { type RootState } from "../../redux/store";

export const selectNotifications = (state: RootState) => state.notifications.data;
export const selectTotalNotificationAmount = (state: RootState) => state.notifications.totalNumberOfResults;
export const selectIsNotificationsLoading = (state: RootState) => state.notifications.isLoading;
export const selectIsNotificationsLoaded = (state: RootState) => state.notifications.isLoaded;
export const selectIsNotificationsError = (state: RootState) => state.notifications.error;
export const selectNewNotificationAmount = (state: RootState) => state.notifications.newNotificationAmount;
// Unused for now
export const selectIsDueForNotificationRefresh = (state: RootState) =>
  Date.now() - state.notifications.lastFetchTime > 30 * 60 * 1000; // 30 min
